module.exports = __webpack_public_path__ + "img/a4be3f5.jpg";